import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Mysterious%20dramatic%20spotlight%20on%20red%20carpet%20with%20intense%20camera%20flashes%20and%20paparazzi%20photography%20atmosphere%2C%20dark%20cinematic%20background%20with%20warm%20golden%20accent%20lighting%20piercing%20through%20shadows%2C%20entertainment%20industry%20glamour%20and%20scandal%20vibe%2C%20rich%20crimson%20and%20black%20tones%2C%20high%20contrast%20dramatic%20noir%20aesthetic%2C%20editorial%20magazine%20photography%20style%20with%20luxurious%20textures%20and%20atmospheric%20depth&width=1600&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-300 whitespace-nowrap">
                {siteInfo.tagline}
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              吃瓜官网
              <span className="block text-xl md:text-2xl lg:text-3xl font-medium text-white/80 mt-2">
                {siteInfo.slogan}
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap text-center"
              >
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap text-center border border-white/20"
              >
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20editorial%20collage%20of%20entertainment%20news%20headlines%2C%20paparazzi%20camera%20flashes%2C%20red%20carpet%20drama%20scenes%2C%20celebrity%20silhouette%20with%20dramatic%20backlighting%2C%20tabloid%20magazine%20aesthetic%20with%20bold%20typography%20overlays%2C%20warm%20amber%20spots%20against%20deep%20black%20background%2C%20high%20energy%20entertainment%20journalism%20atmosphere%2C%20cinematic%20composition%20with%20rich%20textures&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="吃瓜官网 - 娱乐圈黑料爆料第一站"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}